'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonation = exports.fetchDonationFeed = undefined;

var _client = require('../../utils/client');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

/**
 * @function fetch a donation feed for a campaign
 */
var fetchDonationFeed = exports.fetchDonationFeed = function fetchDonationFeed(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchDonationFeed)(params) : (0, _everydayhero.fetchDonationFeed)(params);
};

/**
 * @function deserialize a donation
 */
var deserializeDonation = exports.deserializeDonation = function deserializeDonation(data) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeDonation)(data) : (0, _everydayhero.deserializeDonation)(data);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/feeds/index.js
// module id = 1314
// module chunks = 0